<button mat-button [ngClass]="getClass()" [disabled]="disabled || isLoading" [type]="type" [color]="color"
  (click)="onEmit()">
  <mat-spinner *ngIf="isLoading" [diameter]="20" [color]="spinnerColor"></mat-spinner>
  <div class="span-icon">
    <mat-icon *ngIf="icon && !isLoading">{{ icon }}</mat-icon>
    <span *ngIf="!isLoading"><ng-content></ng-content></span>
  </div>
</button>